import React from "react";
import { Box, Typography, FormControl, InputLabel, Select, MenuItem, FormHelperText, Chip } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

// D8.5.2 — Item de configuración (presentacional; select + chip de estado).

const SettingItem = ({ 
  label, 
  description, 
  value, 
  onChange, 
  options, 
  loading, 
  classes,
  invertStatus = false  // ✅ Nueva prop para invertir la lógica del estado
}) => {
  const getStatusChip = (val) => {
    // ✅ Lógica invertida para settings donde "disabled" = habilitado (como callAutoMessage)
    let isEnabled;
    if (invertStatus) {
      isEnabled = val === 'disabled' || val === 'no';
    } else {
      isEnabled = val === 'enabled' || val === 'yes';
    }
    return (
      <Chip
        label={isEnabled ? i18n.t("settings.states.enabled") : i18n.t("settings.states.disabled")}
        className={`${classes.statusChip} ${isEnabled ? classes.statusEnabled : classes.statusDisabled}`}
        size="small"
      />
    );
  };

  return (
    <Box className={classes.settingItem}>
      <Typography className={classes.settingLabel}>
        {label}
      </Typography>
      {description && (
        <Typography className={classes.settingDescription}>
          {description}
        </Typography>
      )}
      <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
        <FormControl className={classes.formControl} variant="outlined" style={{ flex: 1, minWidth: 150 }}>
          <InputLabel>{label}</InputLabel>
          <Select
            value={value}
            onChange={onChange}
            label={label}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {loading && (
            <FormHelperText className={classes.loadingText}>
              {i18n.t("settings.states.updating")}
            </FormHelperText>
          )}
        </FormControl>
        {getStatusChip(value)}
      </Box>
    </Box>
  );
};

export default SettingItem;
